import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.34 24.356q3.18 0 5.886-1.59a11.9 11.9 0 0 0 4.295-4.295 11.4 11.4 0 0 0 1.59-5.885q0-3.18-1.59-5.886a11.9 11.9 0 0 0-4.295-4.295A11.4 11.4 0 0 0 12.34.815q-3.18 0-5.886 1.59A11.9 11.9 0 0 0 2.16 6.7Q.57 9.406.57 12.586c0 3.18.53 4.081 1.59 5.885a11.9 11.9 0 0 0 4.295 4.295 11.4 11.4 0 0 0 5.886 1.59zm-2.847-5.838a1.06 1.06 0 0 1-1.14 0q-.569-.332-.569-.997V7.65q0-.665.57-.997a1.06 1.06 0 0 1 1.139 0l8.353 5.078q.57.333.57.997t-.57.997z"
    }, null, -1)
  ]))]))
}
export default { render: render }